module.exports = __webpack_public_path__ + "static/assets/8cfc79915028f43d481bd5ea8eafc9ed.png";